import { render, staticRenderFns } from "./Fastpay.vue?vue&type=template&id=7a0526db"
import script from "./Fastpay.vue?vue&type=script&lang=js"
export * from "./Fastpay.vue?vue&type=script&lang=js"
import style0 from "./Fastpay.vue?vue&type=style&index=0&id=7a0526db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports